import { Marker } from '@react-google-maps/api';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import maintenanceCompleted from '../../../../../asset/images/pin/maintenance_completed.svg';
import maintenanceCompletedActive from '../../../../../asset/images/pin/maintenance_completed_on.svg';
import maintenanceStarted from '../../../../../asset/images/pin/maintenance_started.svg';
import maintenanceStartedActive from '../../../../../asset/images/pin/maintenance_started_on.svg';
import { MaintenanceList } from '../../../../../type/maintenance/maintenance.type';
import { MapActions } from '../../../../../redux/map/map.action';
import { UserAgent } from '../../../../../utilities/user-agent';
import { randomPosition } from '../../../../../utilities/random-postion';

export type MaintenanceMarkerProps = {
  activeId: number;
  maintenance: MaintenanceList;
  callback: () => void;
  clusterer: any;
};

export const MaintenanceMarker = (props: MaintenanceMarkerProps) => {
  const {
    maintenance, callback, activeId, clusterer,
  } = props;

  /* Hook */
  const dispatch = useDispatch();

  const lat = useMemo(() => Number(maintenance.lat) + randomPosition(), []);
  const lng = useMemo(() => Number(maintenance.lng) + randomPosition(), []);

  /* Memo */
  const url = useMemo(() => {
    const normal = maintenance.supported_kubun ? maintenanceCompleted : maintenanceStarted;
    const active = maintenance.supported_kubun
      ? maintenanceCompletedActive : maintenanceStartedActive;
    return activeId === maintenance.id ? active : normal;
  }, [UserAgent, activeId, maintenance.id, maintenance.supported_kubun]);

  const scaledSize = useMemo(() => {
    const normal = UserAgent === 'pc' ? 80 : 50;
    const active = UserAgent === 'pc' ? 80 : 50;
    const size = new globalThis.google.maps.Size(
      UserAgent === 'pc' ? 70 : 40,
      activeId === maintenance.id ? active : normal,
    );
    return size;
  }, [UserAgent, activeId, maintenance.id]);

  /* Callback */
  const handleClickMarker = useCallback(
    (e: globalThis.google.maps.MapMouseEvent) => {
      dispatch(MapActions.setSearchPos(null));
      dispatch(MapActions.setRouteInfo(null));
      dispatch(MapActions.setGpsStatus('out'));
      e.domEvent.preventDefault();
      e.domEvent.stopPropagation();
      dispatch(MapActions.setCenterPos({
        lat,
        lng,
      }));
      if (callback) callback();
    },
    [lat, lng, callback],
  );

  return (
    <Marker
      position={{
        lat,
        lng,
      }}
      zIndex={activeId === maintenance.id ? 99 : undefined}
      onClick={handleClickMarker}
      icon={{ url, scaledSize }}
      clusterer={clusterer}
    />
  );
};
